<template>
  <div class="lead-add">
    <sm-inner-loading v-model="onLoading" text="Cargando..." class="filters_loading"/>
    <div class="lead-add__box">
      <h1 class="lead-add__box__header">¡Bienvenido!</h1>
      <div class="lead-add__box__description">Llena los siguientes datos y pronto nos pondremos en contacto contigo</div>
      <sm-input @keyup.enter="send" v-model="fullname" nativeType="text" placeholder="Nombre y apellido" size="medium" inputClass="lead-add__box__username"/>
      <sm-input @keyup.enter="send" v-model="fintech" nativeType="text" placeholder="Empresa" size="medium" inputClass="lead-add__box__username"/>
      <sm-input @keyup.enter="send" v-model="email" nativeType="email" placeholder="Email" size="medium" inputClass="lead-add__box__password"/>
      <sm-input @keyup.enter="send" v-model="mobile" nativeType="text" placeholder="Celular / Whatsapp" size="medium" inputClass="lead-add__box__username"/>
      <div class="lead-add__box__sended-message" v-show="leadCreatedMsg">{{ leadCreatedMsg }}</div>
      <sm-button
        label="ENVIAR DATOS"
        size="medium"
        primary
        class="lead-add__box__button"
        @click="send"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeadAdd',
  data () {
    return {
      fullname: '',
      fintech: '',
      email: '',
      mobile: ''
    }
  },
  computed: {
    onLoading () {
      return this.$store.getters.isLoading
    },
    onError () {
      return Object.is(this.$store.getters.status, 'error')
    },
    leadCreatedMsg () {
      return this.$store.getters.leadCreatedMsg
    }
  },
  methods: {
    send () {
      const { fullname, fintech, email, mobile } = this
      const token = this.$route.query.token

      this.$store.dispatch('leadAdded', { token, fullname, fintech, email, mobile })
    }
  }
}
</script>

<style>
.lead-add {
  background-color: #ffffff;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.lead-add__box {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 80px;
  width: calc(50% - 200px);
}

.lead-add__box__sended-message {
  color: #8BC34A;
  font-size: 17px;
  font-weight: 500;
  line-height: 25px;

  border-radius: 15px;
  background: #8bc34a14;
  margin: 10px 0;
  padding: 5px;
}

.lead-add__box__header {
  color: #999999;
  font-size: 16px;
  font-weight: 400;

  margin-top: -5px;
}

.lead-add__box__description {
  color: #00b19d;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 20px;
}

.lead-add__box__username {
  width: 100%;
}

.lead-add__box__password {
  width: 100%;
}

.lead-add__box__button {
  margin-top: 20px;
  width: 100%;
}

.lead-add__box__button:hover {
  background: rgba(0,83,94,0.93);
}
</style>
